export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyApUB9gxVm96cWvwY-n5EyrWDRp1rbnYqA',
    authDomain: 'fairy-lullaby.firebaseapp.com',
    databaseURL: 'https://fairy-lullaby.firebaseio.com',
    projectId: 'fairy-lullaby',
    storageBucket: 'fairy-lullaby.appspot.com',
    messagingSenderId: '771223338193'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts